import request from '@/utils/request'

let DoctorApi = {

  /*医生列表*/
  list(data) {
    return request._post('/shop/plus.doctor.Index/index', data);
},
/*添加医生*/
add(data) {
    return request._post('/shop/plus.doctor.Index/add', data);
},
/*修改医生*/
edit(data) {
    return request._post('/shop/plus.doctor.Index/edit', data);
},
/*修改医生*/
editParts(data) {
    return request._post('/shop/plus.doctor.Index/editParts', data);
},

/*删除医生*/
del(data) {
    return request._post('/shop/plus.doctor.Index/del', data);
},
/*医生详情*/
detail(data) {
  return request._post('/shop/plus.doctor.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.doctor.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.doctor.Setting/getSetting', data, errorback);
    },
      /*修改部分数据*/
editPart(data) {
    return request._post('/shop/plus.doctor.Index/editPart', data);
},

copy(data) {
    return request._post('/shop/plus.doctor.Index/copy', data);
},
}
export default DoctorApi;



// WEBPACK FOOTER //
// ./src/api/doctor.js